import { render, staticRenderFns } from "./teacher-weeklyplan.vue?vue&type=template&id=99881808&"
import script from "./teacher-weeklyplan.vue?vue&type=script&lang=js&"
export * from "./teacher-weeklyplan.vue?vue&type=script&lang=js&"
import style0 from "./teacher-weeklyplan.vue?vue&type=style&index=0&id=99881808&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports